import keyBy from 'lodash/keyBy';
export var _langList = [{
  value: 'zh-CN',
  label: '中文 (简体)',
  zhLabel: '中文 (简体)',
  s: ['zh-cn', 'zh']
}, {
  value: 'en-US',
  label: 'English',
  zhLabel: '英语',
  s: 'en'
}, {
  value: 'ja-JP',
  label: '日本語',
  zhLabel: '日本语',
  s: 'ja'
}, {
  value: 'ru-RU',
  label: 'Русский',
  zhLabel: '俄语',
  s: 'ru'
}, {
  value: 'pt-PT',
  label: 'Português (Portugal)',
  zhLabel: '葡萄牙语 (葡萄牙)',
  s: 'pt'
}, {
  value: 'fr-FR',
  label: 'Français',
  zhLabel: '法语',
  s: 'fr'
}, {
  value: 'es-ES',
  label: 'Español',
  zhLabel: '西班牙语',
  s: 'es'
}, {
  label: '中文 (香港)',
  value: 'zh-HK',
  zhLabel: '中文 (香港)',
  s: 'zh-hk',
  likeness: ['zh-TW', 'zh-CN']
}, {
  label: '中文 (繁體)',
  value: 'zh-TW',
  zhLabel: '中文 (繁体)',
  s: 'zh-tw',
  likeness: ['zh-HK', 'zh-CN']
}, {
  label: '한국어',
  value: 'ko-KR',
  zhLabel: '韩语',
  s: 'ko'
}, {
  label: 'Türkçe',
  value: 'tr-TR',
  zhLabel: '土耳其语',
  s: 'tr'
}, {
  label: 'Polski',
  value: 'pl-PL',
  zhLabel: '波兰语',
  s: 'pl'
}, {
  label: 'עברית',
  value: 'iw-IL',
  zhLabel: '希伯来语',
  s: ['he', 'iw']
}, {
  label: 'Italiano',
  value: 'it-IT',
  zhLabel: '意大利语',
  s: 'it'
}, {
  label: 'عربية',
  value: 'ar-SA',
  zhLabel: '阿拉伯语',
  s: 'ar'
}, {
  label: 'Čeština',
  value: 'cs-CZ',
  zhLabel: '捷克语',
  s: 'cs'
}, {
  label: 'Dansk',
  value: 'da-DK',
  zhLabel: '丹麦语',
  s: 'da'
}, {
  label: 'Nederlands',
  value: 'nl-NL',
  zhLabel: '荷兰语',
  s: 'nl'
}, {
  label: 'Deutsch',
  value: 'de-DE',
  zhLabel: '德语',
  s: 'de'
}, {
  label: 'हिन्दी',
  value: 'hi-IN',
  zhLabel: '印地语',
  s: 'hi'
}, {
  label: 'Magyar',
  value: 'hu-HU',
  zhLabel: '匈牙利语',
  s: 'hu'
}, {
  label: 'Bahasa Melayu',
  value: 'ms-MY',
  zhLabel: '马来语',
  s: 'ms'
}, {
  label: 'Bahasa Indonesia',
  value: 'in-ID',
  zhLabel: '印尼语',
  s: ['id', 'in']
}, {
  label: 'Română',
  value: 'ro-RO',
  zhLabel: '罗马尼亚语',
  s: 'ro'
}, {
  label: 'Српски',
  value: 'sr-SA',
  zhLabel: '塞尔维亚语',
  s: 'sr'
}, {
  label: 'Slovenčina',
  value: 'sk-SK',
  zhLabel: '斯洛伐克语',
  s: 'sk'
}, {
  label: 'Svenska',
  value: 'sv-SE',
  zhLabel: '瑞典语',
  s: 'sv'
}, {
  label: 'ภาษาไทย',
  value: 'th-TH',
  zhLabel: '泰语',
  s: 'th'
}, {
  label: 'Українська',
  value: 'uk-UA',
  zhLabel: '乌克兰语',
  s: 'uk'
}, {
  label: 'Tiếng Việt',
  value: 'vi-VN',
  zhLabel: '越南语',
  s: 'vi'
}, {
  value: 'pt-BR',
  label: 'Português (Brasil)',
  zhLabel: '葡萄牙语 (巴西)',
  s: 'pt-br',
  likeness: ['pt-PT']
}, {
  value: 'en-ID',
  label: 'English (ID)',
  zhLabel: '英语 (印度尼西亚)',
  s: ['en-id', 'en'],
  likeness: ['en-US']
}, {
  value: 'en-MY',
  label: 'English (MY)',
  zhLabel: '英语 (马来西亚)',
  s: ['en-my', 'en'],
  likeness: ['en-US']
}, {
  value: 'en-PH',
  label: 'English (PH)',
  zhLabel: '英语 (菲律宾)',
  s: ['en-ph', 'en'],
  likeness: ['en-US']
}, {
  value: 'en-SG',
  label: 'English (SG)',
  zhLabel: '英语 (新加坡)',
  s: ['en-sg', 'en'],
  likeness: ['en-US']
}, {
  value: 'en-TH',
  label: 'English (TH)',
  zhLabel: '英语 (泰国)',
  s: ['en-th', 'en'],
  likeness: ['en-US']
}, {
  value: 'en-VN',
  label: 'English (VN)',
  zhLabel: '英语 (越南)',
  s: ['en-vn', 'en'],
  likeness: ['en-US']
}];
export var langList = _langList.map(function (_ref) {
  var label = _ref.label,
    value = _ref.value;
  return {
    label: label,
    value: value,
    alias: value.substring(0, 1).toUpperCase() + value.substring(1, 2)
  };
});
export var zhLangList = _langList.map(function (_ref2) {
  var value = _ref2.value,
    zhLabel = _ref2.zhLabel;
  return {
    label: zhLabel,
    value: value,
    alias: value.substring(0, 1).toUpperCase() + value.substring(1, 2)
  };
});
export var langMap = keyBy(_langList, 'value');

// TODO 后续将废弃
export var defaultLangList = langList.slice(0, 7);